import { Fragment } from "react";
import { TbExternalLink } from "react-icons/tb";
import { Grid, IconButton } from "@mui/material";

import { Label, TextField } from "../../../components";

export default function FormOne({ formData }) {
  return (
    <Fragment>
      <Grid item xs={6}>
        <Label title="Site Category" />

        <TextField
          size="small"
          multiline
          name="siteCategory"
          disabled
          value={formData.siteCategory.map((cat) => cat.name).join(",")}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Website" />

        <TextField
          size="small"
          multiline
          name="audienceLocation"
          disabled
          value={formData.audienceLocation
            .map((loc) => loc.country_name)
            .join(",")}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Language" />

        <TextField
          size="small"
          multiline
          name="audienceLanguages"
          disabled
          value={formData.audienceLanguages
            .map((lan) => lan.language)
            .join(",")}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Facebook URL" />

        <TextField
          disabled
          size="small"
          name="socialMedia.facebook"
          value={formData.socialMedia.facebook}
          InputProps={{
            endAdornment: !!formData.socialMedia.facebook && (
              <IconButton
                onClick={() =>
                  linkOpen(
                    "https://facebook.com/" +
                      !!formData.socialMedia.facebook.replace(
                        /(?:https?|ftp):\/\/[\n\S]+/g,
                        ""
                      )
                  )
                }
              >
                <TbExternalLink />
              </IconButton>
            ),
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Instagram URL" />

        <TextField
          disabled
          size="small"
          name="socialMedia.instagram"
          value={formData.socialMedia.instagram}
          inputProps={{ "aria-label": "Without label" }}
          InputProps={{
            endAdornment: !!formData.socialMedia.instagram && (
              <IconButton
                onClick={() =>
                  linkOpen(
                    "https://instagram.com/" +
                      !!formData.socialMedia.instagram.replace(
                        /(?:https?|ftp):\/\/[\n\S]+/g,
                        ""
                      )
                  )
                }
              >
                <TbExternalLink />
              </IconButton>
            ),
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Twitter URL" />

        <TextField
          disabled
          size="small"
          name="socialMedia.twitter"
          value={formData.socialMedia.twitter}
          InputProps={{
            endAdornment: !!formData.socialMedia.twitter && (
              <IconButton
                onClick={() =>
                  linkOpen(
                    "https://twitter.com/" +
                      !!formData.socialMedia.twitter.replace(
                        /(?:https?|ftp):\/\/[\n\S]+/g,
                        ""
                      )
                  )
                }
              >
                <TbExternalLink />
              </IconButton>
            ),
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <Label title="Whatsapp Number" />

        <TextField
          disabled
          size="small"
          value={formData.socialMedia.whatsapp}
          label="Whatsapp Number"
          name="socialMedia.whatsapp"
          InputProps={{
            endAdornment: !!formData.socialMedia.whatsapp && (
              <IconButton
                onClick={() =>
                  linkOpen("https://wa.me/" + !!formData.socialMedia.whatsapp)
                }
              >
                <TbExternalLink />
              </IconButton>
            ),
          }}
        />
      </Grid>
    </Fragment>
  );

  function linkOpen(val) {
    window.open(val, "_blank");
  }
}
